/**
 * 揭曉後要不要補抓背包與每日限購。
 *
 * 付款回程輪詢收斂（returnResolved）與當頁刷卡立即成功（resultReady）的回應都不帶
 * inventory_html / eligibility_update，揭曉後要另外抓；純點數立即成功的回應已帶，
 * 呼叫端以 fromPointsOnly 標記，不重抓。
 */
export function shouldRefreshAfterReveal(event) {
    if (event.type === 'returnResolved') {
        return true;
    }
    return event.type === 'resultReady' && !event.fromPointsOnly;
}
